import { useEffect } from "react";
import { useLocation } from "react-router";
import { replaceUrlUuidsWithPlaceholders, resolvePageTitle } from "./navigationUtils";
import { getGoogleAnalyticsKey, isLocalhostDevMode } from "./utils";

const GAKey = getGoogleAnalyticsKey();

const anonymizedLocation = (pathname: string) =>
  window.location.origin + replaceUrlUuidsWithPlaceholders(pathname).path;

const gtag: (...args: unknown[]) => void = function () {
  // eslint-disable-next-line prefer-rest-params
  window.dataLayer?.push(arguments);
};

if (GAKey) {
  window.dataLayer = window.dataLayer || [];
  gtag("js", new Date());
  gtag("config", GAKey, {
    send_page_view: false,
    page_location: anonymizedLocation(window.location.pathname),
    ...(isLocalhostDevMode() && { debug_mode: true }),
  });

  const script = document.createElement("script");
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GAKey}`;
  document.head.appendChild(script);
}

export const useGoogleAnalytics = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    if (GAKey) {
      gtag("set", { page_location: anonymizedLocation(pathname), page_title: resolvePageTitle(pathname) });
      gtag("event", "page_view");
    }
  }, [pathname]);
};
